import { useQuery } from '@tanstack/react-query';
import { submitGameMission } from '~/api';
import { SubmitGameMissionRequestData } from '~/types/missionGameApi';
import { MINUTE } from '~/constants';
import useToast from '~/store/useToast';
import missionGameKey from './missionGameKey';

const useGetGameResultQuery = (request: SubmitGameMissionRequestData) => {
  const { showToast } = useToast();
  return useQuery({
    queryKey: missionGameKey.getGameResultInfo(request),
    queryFn: async () => {
      const response = submitGameMission(request);
      return response;
    },
    select: (data) => {
      if (data) {
        return data.data;
      } else {
        showToast('error', 'fetch list error');
        return { image_file_path: '', type: '', story: '' };
      }
    },
    // 매 페이지 새로 접근시마다 api 새로 호출
    placeholderData: undefined,
    staleTime: 30 * MINUTE,
  });
};

export default useGetGameResultQuery;
